import {
  Breadcrumb,
  Button,
  Card,
  Checkbox,
  DatePicker,
  Divider,
  Empty,
  Popconfirm,
  Row,
  Space,
  Tabs,
  TableColumnsType,
  Tooltip,
  Tour,
  TourProps,
  Typography,
} from "antd";
import React, { useContext, useEffect, useRef, useState } from "react";
import { ColumnComponent } from "../../components/ui";
import Table from "antd/es/table";
import QuickbooksContext from "../../context/QuickbooksContext";
import LayoutContext from "../../context/LayoutContext";
import dayjs, { Dayjs } from "dayjs";
import { InvoiceDrawer } from "../../components/collections/InvoiceDrawer";
import DataContext from "../../context/DataContext";
import { useParams, useSearchParams } from "react-router-dom";
import { MultipleSelect, SearchInput } from "../../components/functional";
import { exportDetailFile } from "../../utils/func/ExportFile";
import {
  DownloadOutlined,
  MailOutlined,
  EditOutlined,
  QuestionCircleOutlined,
  PictureOutlined,
  SyncOutlined,
} from "@ant-design/icons";
import AuthContext from "../../context/AuthContext";
import { USDollar } from "../../utils/func/currency";
import { TablePaginationConfig } from "antd/lib";
import { FilterValue } from "antd/es/table/interface";
import { ModalCollectionsBulkUpdate } from "../../components/collections";
import { useDemoModal } from "../../hooks";
import { ColumnsType, ColumnType } from "antd/lib/table";
import { InvoiceProps } from "../../interfaces/interfaces";
import * as htmlToImage from "html-to-image";

const { Text, Link } = Typography;

interface TableParams {
  pagination?: TablePaginationConfig;
  sortField?: string;
  filters?: Record<string, FilterValue>;
}

export const DetailClient = () => {
  const { idClient } = useParams();
  const { DemoModal, openModalDemo } = useDemoModal();
  const [items, setItems] = useState<any[]>([]);
  const [searchParams] = useSearchParams();
  const [activeTab, setActiveTab] = useState<string>("Current");
  const [asOfDate, setAsOfDate] = useState(dayjs());
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [hasSelected, setHasSelected] = useState(false);
  const [localLoading, setLocalLoading] = useState(false);
  const [selectedCustomerToEmail, setSelectedCustomerToEmail] = useState("");
  const [selectedCurrent, setSelectedCurrent] = useState<React.Key[]>([]);
  const [selected_1_30, setSelected_1_30] = useState<React.Key[]>([]);
  const [selected_31_60, setSelected_31_60] = useState<React.Key[]>([]);
  const [selected_61_90, setSelected_61_90] = useState<React.Key[]>([]);
  const [selected_90, setSelected_90] = useState<React.Key[]>([]);
  const {
    detailData,
    isInvoiceDrawerOpen,
    invoiceListSelected,
    invoiceSelected,
    indexInvoiceSelected,
    qbLoading,
    getData,
    handleSelectInvoiceList,
    handleCancelSelectInvoiceList,
    updateSelectedInvoice,
    handleSelectInvoice,
    handleGetQbData,
    handleChangeFilters,
    handleBulkEdit,
    onChangeSearchQuery,
    onDemandReminderSingle,
  } = useContext(QuickbooksContext);
  const [forceReset, setForceReset] = useState(false);
  const [hideColumnsClass, setHideColumnsClass] = useState(false);
  const [columnsFiltered, setColumnsFiltered] =
    useState<ColumnsType<InvoiceProps>>();
  const { clientInfo, isDemoEnv, authLoading, profileInfo } =
    useContext(AuthContext);
  const [customerFiltered, setCustomerFiltered] = useState([]);
  const [customerSelected, setCustomerSelected] = useState([]);
  const [statusSelected, setStatusSelected] = useState([]);
  const [nextFollowUpDate, setNextFollowUpDate] = useState<Dayjs | null>(null);
  const [hasFollowUpDate, setHasFollowUpDate] = useState(false);
  const [defaultSortKey, setDefaultSortKey] = useState({
    name: "2",
    order: "ascend",
  });
  const [internalLoading, setInternalLoading] = useState(false);
  const [tableParams, setTableParams] = useState<TableParams>({
    pagination: {
      onChange: (_, pageSize) => {
        setTableParams((prev) => {
          return {
            ...prev,
            pagination: {
              ...prev.pagination,
              pageSize: pageSize,
            },
          };
        });
      },
    },
  });
  const {
    getData: getListData,
    statusList,
    customerOptions,
    statusOptions,
    isTourOpen,
    handleSuccess,
    handleTour,
  } = useContext(DataContext);
  const { setPageTitle, setPageExtra } = useContext(LayoutContext);
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null);
  const ref7 = useRef(null);
  const ref8 = useRef(null);
  const ref9 = useRef(null);
  const screenRef = useRef(null);

  useEffect(() => {
    onChangeSearchQuery("");
    if (isDemoEnv) {
      let tourOpened = localStorage.getItem("tour-detail");
      if (!tourOpened) {
        handleTour(true);
        localStorage.setItem("tour-detail", "true");
      }
    }
  }, []);

  useEffect(() => {
    if (customerFiltered.length === 1) {
      setSelectedCustomerToEmail(customerFiltered[0]);
    } else if (customerSelected.length === 1) {
      setSelectedCustomerToEmail(customerSelected[0]);
    } else {
      setSelectedCustomerToEmail("");
    }
  }, [customerFiltered, customerSelected]);

  useEffect(() => {
    setColumnsFiltered(
      columns.map((item) => {
        if (
          item.key === "8" ||
          item.key === "9" ||
          item.key === "10" ||
          item.key === "11" ||
          item.key === "12"
        ) {
          item.hidden = hideColumnsClass;
        }
        return {
          ...item,
        };
      }),
    );
  }, [hideColumnsClass]);

  useEffect(() => {
    if (
      profileInfo?.preferences?.collections?.detail?.columns &&
      profileInfo.preferences.collections.detail.columns.length > 0
    ) {
      setColumnsFiltered(
        columns.map((item) => {
          if (
            profileInfo?.preferences?.collections?.detail?.columns?.includes(
              (item as ColumnType<InvoiceProps>).dataIndex as any,
            )
          ) {
            item.hidden = false;
          } else {
            item.hidden = true;
          }
          return {
            ...item,
          };
        }),
      );
    }
  }, [profileInfo?.preferences?.collections?.detail?.columns]);

  useEffect(() => {
    const defaultKey = profileInfo?.preferences?.collections?.detail
      ?.defaultSortColumnKey || { name: "2", order: "ascend" };
    setDefaultSortKey(defaultKey);
    setColumnsFiltered(
      columns.map((item) => {
        if (item.key === defaultKey.name) {
          item.defaultSortOrder =
            (defaultKey.order as "ascend" | "descend") || "ascend";
        }
        return {
          ...item,
        };
      }),
    );
  }, [profileInfo]);

  useEffect(() => {
    if (
      selectedCurrent.length > 0 ||
      selected_1_30.length > 0 ||
      selected_31_60.length > 0 ||
      selected_61_90.length > 0 ||
      selected_90.length > 0
    ) {
      setHasSelected(true);
    } else {
      setHasSelected(false);
    }
  }, [
    selectedCurrent,
    selected_1_30,
    selected_31_60,
    selected_61_90,
    selected_90,
  ]);

  useEffect(() => {
    if (idClient) {
      getListData("customer", idClient);
      getListData("status", idClient);
    }
  }, [idClient]);

  useEffect(() => {
    if (searchParams.get("filter") && searchParams.get("filter") !== null) {
      const filter = searchParams.get("filter") || "";
      setActiveTab(filter);
    }
  }, [searchParams, items]);

  useEffect(() => {
    getSourceData();
  }, []);

  useEffect(() => {
    setPageTitle("A/R Aging Detail");

    if (!isDemoEnv) {
      setPageExtra(
        <>
          {detailData.lastUpdate && detailData.lastUpdate.CollectionsDate && (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: "2px",
              }}
            >
              <Text
                style={{
                  color: "var(--slate-400)",
                  fontSize: "0.65rem",
                  fontWeight: 700,
                  letterSpacing: "0.5px",
                  textTransform: "uppercase",
                  lineHeight: 1,
                }}
              >
                Last Synced
              </Text>
              <Text
                style={{
                  color: "var(--slate-700)",
                  fontSize: "0.875rem",
                  fontWeight: 600,
                  lineHeight: 1.2,
                }}
              >
                {dayjs
                  .utc(detailData.lastUpdate.CollectionsDate)
                  .format("MMM DD, YYYY, h:mm A")}
              </Text>
            </div>
          )}
          <Button
            type="primary"
            icon={<SyncOutlined />}
            style={{
              backgroundColor: "#2b8cee",
              borderColor: "#2b8cee",
              fontWeight: 600,
              fontSize: "0.875rem",
              height: "auto",
              padding: "8px 20px",
              borderRadius: "20px",
            }}
            loading={qbLoading}
            onClick={() => {
              idClient &&
                handleGetQbData(idClient, () => {
                  getData({
                    endpoint: "detail",
                    idClient,
                    filters: {
                      customer:
                        customerSelected.length > 0 ? customerSelected : null,
                      status: statusSelected.length > 0 ? statusSelected : null,
                    },
                  });
                  idClient && getListData("customer", idClient);
                });
            }}
          >
            Refresh From QuickBooks
          </Button>
        </>,
      );
    } else {
      setPageExtra(null);
    }

    return () => {
      setPageTitle("");
      setPageExtra(null);
    };
  }, [
    clientInfo,
    isDemoEnv,
    detailData,
    qbLoading,
    idClient,
    customerSelected,
    statusSelected,
  ]);

  const getSourceData = () => {
    if (idClient)
      if (
        searchParams.get("add_filter") &&
        searchParams.get("add_filter") !== null
      ) {
        const idCustomer = searchParams.get("add_filter") || "";
        if (idCustomer !== "") {
          handleChangeFilters("detail", idClient, "customer", [idCustomer]);
          setCustomerFiltered([idCustomer] as any);
        }
      } else if (
        searchParams.get("status") &&
        searchParams.get("status") !== null
      ) {
        const idStatus = searchParams.get("status") || "";
        if (idStatus !== "") {
          handleChangeFilters("detail", idClient, "status", [idStatus]);
          setStatusSelected([idStatus] as any);
        }
      } else {
        getData({ endpoint: "detail", idClient });
      }
  };

  useEffect(() => {
    if (
      selected_31_60.length === 0 &&
      selectedCurrent.length === 0 &&
      selected_1_30.length === 0 &&
      selected_61_90.length === 0 &&
      selected_90.length === 0
    ) {
      setForceReset(true); // Force reset selection
      setTimeout(() => setForceReset(false), 10); // Reapply selection after a short delay
    }
  }, [selected_31_60]);

  const initial_selection_state = {
    selectedRowKeys: [],
    selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
  };

  const rowSelectionCurrent = forceReset
    ? initial_selection_state
    : {
        selectedCurrent,
        onChange: (newSelectedRowKeys: React.Key[]) => {
          setSelectedCurrent(newSelectedRowKeys);
        },
        selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
      };

  const rowSelection1_30 = forceReset
    ? initial_selection_state
    : {
        selected_1_30,
        onChange: (newSelectedRowKeys: React.Key[]) => {
          setSelected_1_30(newSelectedRowKeys);
        },
        selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
      };

  const rowSelection_31_60 = forceReset
    ? initial_selection_state
    : {
        selected_31_60,
        onChange: (newSelectedRowKeys: React.Key[]) => {
          setSelected_31_60(newSelectedRowKeys);
        },
        selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
      };

  const rowSelection_61_90 = forceReset
    ? initial_selection_state
    : {
        selected_61_90,
        onChange: (newSelectedRowKeys: React.Key[]) => {
          setSelected_61_90(newSelectedRowKeys);
        },
        selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
      };

  const rowSelection_90 = forceReset
    ? initial_selection_state
    : {
        selected_90,
        onChange: (newSelectedRowKeys: React.Key[]) => {
          setSelected_90(newSelectedRowKeys);
        },
        selections: [Table.SELECTION_ALL, Table.SELECTION_NONE],
      };

  useEffect(() => {
    setTableParams({
      pagination: {
        pageSize: 100,
        onChange: (_, pageSize) => {
          setTableParams((prev) => {
            return {
              ...prev,
              pagination: {
                ...prev.pagination,
                pageSize: pageSize,
              },
            };
          });
        },
      },
    });
  }, []);

  useEffect(() => {
    const newItems = [];
    if (detailData) {
      console.log(detailData);
      detailData.current.length > 0 &&
        newItems.push({
          key: "Current",
          label: (
            <Space size={8}>
              <strong>Current</strong>
              <span style={{ color: "var(--slate-500)", fontSize: "0.875rem" }}>
                {USDollar.format(detailData.totalCurrent)}
              </span>
            </Space>
          ),
          children: (
            <Card
              bordered={false}
              className="card overflow_x detail-client__tabs__card"
              ref={ref8}
            >
              {detailData.current.length > 0 ? (
                <Table
                  className="detail-client__tabs__card__table"
                  rowSelection={rowSelectionCurrent}
                  pagination={tableParams.pagination}
                  bordered
                  columns={columnsFiltered}
                  dataSource={detailData.current}
                  size="small"
                  rowKey="DocNumber"
                  tableLayout="auto"
                />
              ) : (
                <Empty />
              )}
            </Card>
          ),
        });
      detailData["1-30"].length > 0 &&
        newItems.push({
          key: "1-30",
          label: (
            <Space size={8}>
              <strong>1-30</strong>
              <span style={{ color: "var(--slate-500)", fontSize: "0.875rem" }}>
                {USDollar.format(detailData.total_1_30)}
              </span>
            </Space>
          ),
          children: (
            <Card
              bordered={false}
              className="card overflow_x detail-client__tabs__card"
            >
              {detailData["1-30"].length > 0 ? (
                <Table
                  className="detail-client__tabs__card__table"
                  rowSelection={rowSelection1_30}
                  pagination={tableParams.pagination}
                  bordered
                  columns={columnsFiltered}
                  dataSource={detailData["1-30"]}
                  size="small"
                  rowKey="DocNumber"
                  tableLayout="auto"
                />
              ) : (
                <Empty />
              )}
            </Card>
          ),
        });
      detailData["31-60"].length > 0 &&
        newItems.push({
          key: "31-60",
          label: (
            <Space size={8}>
              <strong>31-60</strong>
              <span style={{ color: "var(--slate-500)", fontSize: "0.875rem" }}>
                {USDollar.format(detailData.total_31_60)}
              </span>
            </Space>
          ),
          children: (
            <Card
              bordered={false}
              className="card overflow_x detail-client__tabs__card"
              loading={localLoading}
            >
              {detailData["31-60"].length > 0 ? (
                <Table
                  className="detail-client__tabs__card__table"
                  rowSelection={rowSelection_31_60}
                  pagination={tableParams.pagination}
                  bordered
                  columns={columnsFiltered}
                  dataSource={detailData["31-60"]}
                  size="small"
                  rowKey="DocNumber"
                  tableLayout="auto"
                />
              ) : (
                <Empty />
              )}
            </Card>
          ),
        });
      detailData["61-90"].length > 0 &&
        newItems.push({
          key: "61-90",
          label: (
            <Space size={8}>
              <strong>61-90</strong>
              <span style={{ color: "var(--slate-500)", fontSize: "0.875rem" }}>
                {USDollar.format(detailData.total_61_90)}
              </span>
            </Space>
          ),
          children: (
            <Card
              bordered={false}
              className="card overflow_x detail-client__tabs__card"
            >
              {detailData["61-90"].length > 0 ? (
                <Table
                  className="detail-client__tabs__card__table"
                  rowSelection={rowSelection_61_90}
                  pagination={tableParams.pagination}
                  bordered
                  columns={columnsFiltered}
                  dataSource={detailData["61-90"]}
                  size="small"
                  rowKey="DocNumber"
                  tableLayout="auto"
                />
              ) : (
                <Empty />
              )}
            </Card>
          ),
        });
      detailData[">90"].length > 0 &&
        newItems.push({
          key: ">90",
          label: (
            <Space size={8}>
              <strong>&gt;90</strong>
              <span style={{ color: "var(--slate-500)", fontSize: "0.875rem" }}>
                {USDollar.format(detailData.total_90)}
              </span>
            </Space>
          ),
          children: (
            <Card
              bordered={false}
              className="card overflow_x detail-client__tabs__card"
            >
              {detailData[">90"].length > 0 ? (
                <Table
                  rowSelection={rowSelection_90}
                  className="detail-client__tabs__card__table"
                  pagination={tableParams.pagination}
                  bordered
                  columns={columnsFiltered}
                  dataSource={detailData[">90"]}
                  size="small"
                  rowKey="DocNumber"
                  tableLayout="auto"
                  loading={qbLoading || authLoading}
                />
              ) : (
                <Empty />
              )}
            </Card>
          ),
        });

      setItems(newItems);
    }
  }, [
    detailData,
    columnsFiltered,
    selectedCurrent,
    selected_1_30,
    selected_31_60,
    selected_61_90,
    selected_90,
    forceReset,
    tableParams.pagination,
  ]);

  const editInvoices = (newStatus: {
    Status: string | null;
    LastContact: Dayjs | null;
    NewNote: string | null;
    NextFollowUp: Dayjs | null;
  }) => {
    if (isDemoEnv) {
      openModalDemo();
    } else {
      setLocalLoading(true);
      let selectedRowsToEdit = [
        ...selectedCurrent,
        ...selected_1_30,
        ...selected_31_60,
        ...selected_61_90,
        ...selected_90,
      ];
      clientInfo &&
        handleBulkEdit({
          endpoint: "invoice",
          idClient: clientInfo?._id,
          items: selectedRowsToEdit as string[],
          newStatus,
          next: () => {
            setSelectedCurrent([]);
            setSelected_1_30([]);
            setSelected_31_60([]);
            setSelected_61_90([]);
            setSelected_90([]);
            if (idClient)
              handleChangeFilters(
                "detail",
                idClient,
                "customer",
                customerFiltered,
              );
          },
        });
    }
    setIsEditModalOpen(false);
    setLocalLoading(false);
  };

  const sendIndividualReminders = () => {
    if (isDemoEnv) {
      openModalDemo();
    } else {
      if (clientInfo) {
        let selectedRowsToEdit = [
          ...selectedCurrent,
          ...selected_1_30,
          ...selected_31_60,
          ...selected_61_90,
          ...selected_90,
        ];
        selectedRowsToEdit.length > 0 &&
          onDemandReminderSingle({
            idClient: clientInfo._id,
            docNumberList: selectedRowsToEdit as string[],
            next: () => {
              clientInfo &&
                handleBulkEdit({
                  endpoint: "invoice",
                  idClient: clientInfo?._id,
                  items: selectedRowsToEdit as string[],
                  newStatus: {
                    Status: null,
                    LastContact: dayjs(),
                    NewNote: "Invoices Notification sent",
                    NextFollowUp: null,
                  },
                  next: () => {
                    setSelectedCurrent([]);
                    setSelected_1_30([]);
                    setSelected_31_60([]);
                    setSelected_61_90([]);
                    setSelected_90([]);
                    setHasSelected(false);
                    if (idClient)
                      handleChangeFilters(
                        "detail",
                        idClient,
                        "customer",
                        customerFiltered,
                      );
                  },
                });
            },
          });
      }
    }
  };

  const steps: TourProps["steps"] = [
    {
      title: "Toolbar",
      description:
        "This is the toolbar, where you can find all the actions, filters, and export options.",
      target: () => ref1.current,
    },
    {
      title: "As of Date",
      description: "This is the date of the A/R Aging Detail.",
      target: () => ref2.current,
    },
    {
      title: "Edit Single/Multiple Invoice(s)",
      description:
        "Edit the status, email address, phone number of one or multiple invoices at once.",
      target: () => ref3.current,
    },
    {
      title: "Take screenshot",
      description:
        "Take an screenshot of the A/R Aging Detail and copy it to the clipboard.",
      target: () => ref9.current,
    },
    {
      title: "Send Email Reminder",
      description:
        "Send Invoice reminder when one or multiple invoices are selected",
      target: () => ref4.current,
    },
    {
      title: "Export Data",
      description: "Export the A/R Aging Detail data to a CSV file.",
      target: () => ref5.current,
    },
    {
      title: "Filter By Status",
      description: "Filter the A/R Aging Detail by status.",
      target: () => ref6.current,
    },
    {
      title: "Filter By Customer",
      description: "Filter the A/R Aging Detail by customer.",
      target: () => ref7.current,
    },
    {
      title: "A/R Detail",
      description: "Here you can see the A/R Detail By Aging.",
      target: () => ref8.current,
    },
  ];

  const handleScreenshot = async () => {
    if (screenRef.current) {
      setInternalLoading(true);
      setHideColumnsClass(true);
      await new Promise((resolve, reject) => {
        resolve(
          setTimeout(() => {
            htmlToImage
              .toBlob(document.getElementById("screenshot") as HTMLElement)
              .then(async function (blob) {
                if (!blob) return;
                await navigator.clipboard.write([
                  new ClipboardItem({ "image/png": blob }),
                ]);
                handleSuccess(false, "Failed to copy screenshot. Try again.");
                setInternalLoading(false);
              });
            handleSuccess(true, "Screenshot copied to clipboard");
          }, 2000),
        );
      });
      setHideColumnsClass(false);
    }
  };

  const columns: TableColumnsType<InvoiceProps> = [
    {
      title: "Created at",
      key: "1",
      dataIndex: "TxnDate",
      render: (_, { TxnDate }) => (
        <>{TxnDate ? dayjs(TxnDate).format("MM/DD/YYYY") : ""}</>
      ),
      className: "table-row",
      sorter: {
        multiple: 1,
        compare: (a, b) =>
          new Date(a.TxnDate).getTime() - new Date(b.TxnDate).getTime(),
      },
    },
    {
      title: "Name",
      key: "2",
      dataIndex: "CustomerRef",
      // width: "100%",
      render: (_, { CustomerRef }) => (
        <Link>{CustomerRef ? CustomerRef.name : ""}</Link>
      ),
      onCell: (record, index) => {
        return {
          onClick: () => handleSelectInvoiceList("detail", record),
        };
      },
      sorter: {
        compare: (a, b) =>
          (a.CustomerRef?.name || "").localeCompare(b.CustomerRef?.name || ""),
        multiple: 2,
      },
      className: "table-row",
    },
    {
      title: "Num",
      key: "3",
      dataIndex: "DocNumber",
      sorter: {
        compare: (a, b) => (a.DocNumber || "").localeCompare(b.DocNumber || ""),
        multiple: 3,
      },
      render: (_, { DocNumber }) => <Link>{DocNumber || ""}</Link>,
      onCell: (record) => {
        return {
          onClick: () => handleSelectInvoiceList("detail", record),
        };
      },
      className: "table-row",
    },
    {
      title: "Type",
      key: "4",
      dataIndex: "TransactionType",
      sorter: {
        compare: (a, b) =>
          (a.TransactionType || "").localeCompare(b.TransactionType || ""),
        multiple: 4,
      },
      className: "table-row",
    },
    {
      title: "Terms",
      key: "5",
      dataIndex: "SalesTermRef",
      render: (_, { SalesTermRef }) => (
        <>{SalesTermRef ? SalesTermRef.name : ""}</>
      ),
      sorter: {
        compare: (a, b) =>
          (a.SalesTermRef?.name || "").localeCompare(b.SalesTermRef?.name),
        multiple: 5,
      },
      className: "table-row",
    },
    {
      title: "Due Date",
      dataIndex: "DueDate",
      key: "6",
      render: (_, row) => (
        <>
          {row.DueDate
            ? dayjs(row.DueDate).format("MM/DD/YYYY")
            : row.TxnDate
              ? dayjs(row.TxnDate).format("MM/DD/YYYY")
              : ""}
        </>
      ),
      className: "table-row",
      sorter: {
        compare: (a, b) =>
          new Date(a.DueDate).getTime() - new Date(b.DueDate).getTime(),
        multiple: 6,
      },
    },
    {
      title: "Balance",
      key: "7",
      dataIndex: "Balance",
      className: "align-right table-row",
      sorter: {
        compare: (a, b) => a.Balance - b.Balance,
        multiple: 7,
      },
      render: (_, { Balance }) => <Link>{USDollar.format(Balance) || ""}</Link>,
      onCell: (record) => {
        return {
          onClick: () => handleSelectInvoiceList("detail", record),
        };
      },
    },
    {
      title: "Ship Via",
      key: "13",
      dataIndex: "ShipMethodRef",
      responsive: ["md", "lg", "xl", "xxl"],
      className: `table-row`,
      render: (_, { ShipMethodRef }) => (
        <>{ShipMethodRef ? ShipMethodRef.name : ""}</>
      ),
    },
    {
      title: "Ship Date",
      key: "14",
      dataIndex: "ShipDate",
      responsive: ["md", "lg", "xl", "xxl"],
      render: (_, { ShipDate }) => (
        <>{ShipDate ? dayjs(ShipDate).format("MM/DD/YYYY") : ""}</>
      ),
      className: `table-row`,
      sorter: {
        compare: (a, b) =>
          new Date(a.ShipDate as any).getTime() -
          new Date(b.ShipDate as any).getTime(),
        multiple: 9,
      },
    },
    {
      title: "Status",
      key: "8",
      dataIndex: "status_field",
      render: (_, { status_field }) => (
        <>
          {status_field && status_field[0].Label ? status_field[0].Label : ""}
        </>
      ),
      className: "table-row",
      sorter: {
        compare: (a, b) =>
          (a &&
            b &&
            a.status_field &&
            b.status_field &&
            a.status_field[0].Label.localeCompare(b.status_field[0].Label)) ||
          0,
        multiple: 8,
      },
    },
    {
      title: "Last Contact",
      key: "9",
      dataIndex: "CollectionDetails",
      responsive: ["md", "lg", "xl", "xxl"],
      render: (_, { CollectionDetails }) => (
        <>
          {CollectionDetails?.LastNotes &&
          CollectionDetails?.LastNotes.length > 0
            ? dayjs(CollectionDetails?.LastNotes[0]?.date).format("MM/DD/YYYY")
            : CollectionDetails?.LastContact
              ? dayjs(CollectionDetails?.LastContact).format("MM/DD/YYYY")
              : ""}
        </>
      ),
      className: `table-row`,
      sorter: {
        compare: (a, b) =>
          new Date(a.CollectionDetails.LastContact as any).getTime() -
          new Date(b.CollectionDetails.LastContact as any).getTime(),
        multiple: 9,
      },
    },
    {
      title: "Last Note",
      key: "11",
      dataIndex: "CollectionDetails",
      responsive: ["md", "lg", "xl", "xxl"],
      render: (_, { CollectionDetails }) => (
        <>
          {CollectionDetails?.LastNotes &&
          CollectionDetails?.LastNotes.length > 0
            ? CollectionDetails?.LastNotes[0]?.body
            : ""}
        </>
      ),
      className: `table-row`,
      sorter: {
        compare: (a, b) =>
          (
            (a?.CollectionDetails?.LastNotes &&
              a?.CollectionDetails?.LastNotes[0]?.body) ||
            ""
          ).localeCompare(
            (b?.CollectionDetails?.LastNotes &&
              (b?.CollectionDetails?.LastNotes[0]?.body as any)) ||
              "",
          ),
        multiple: 11,
      },
    },
    {
      title: "By",
      key: "12",
      dataIndex: "CollectionDetails",
      responsive: ["md", "lg", "xl", "xxl"],
      // width: "100%",
      render: (_, { CollectionDetails }) => (
        <>
          {CollectionDetails.LastNotes &&
          CollectionDetails?.LastNotes?.length > 0
            ? CollectionDetails.LastNotes[0]?.user?.name
            : ""}
        </>
      ),
      className: `table-row`,
      sorter: {
        compare: (a, b) =>
          (
            (a?.CollectionDetails?.LastNotes &&
              a?.CollectionDetails?.LastNotes[0]?.user?.name) ||
            ""
          ).localeCompare(
            (b?.CollectionDetails?.LastNotes &&
              b?.CollectionDetails?.LastNotes[0]?.user?.name) ||
              "",
          ),
        multiple: 12,
      },
    },
  ];

  return (
    <>
      <Breadcrumb
        style={{ marginBottom: "16px" }}
        items={[{ title: "Home" }, { title: "A/R Aging Detail" }]}
      />
      <Row gutter={[24, 0]}>
        <ColumnComponent>
          <div ref={ref1} className="detail-client__filters-container">
            <div className="detail-client__filters-row">
              <div className="filter-group">
                <label className="filter-label">Actions</label>
                <div className="filter-actions">
                  <div ref={ref3}>
                    <Tooltip title="Edit">
                      <Button
                        type="text"
                        className="action-btn"
                        icon={<EditOutlined style={{ fontSize: "18px" }} />}
                        disabled={!hasSelected}
                        size="large"
                        onClick={() => setIsEditModalOpen(true)}
                      />
                    </Tooltip>
                  </div>
                  <div ref={ref9}>
                    <Tooltip title="Take Screenshot">
                      <Button
                        loading={internalLoading}
                        disabled={hideColumnsClass}
                        type="text"
                        className="action-btn"
                        icon={<PictureOutlined style={{ fontSize: "18px" }} />}
                        size="large"
                        onClick={handleScreenshot}
                      />
                    </Tooltip>
                  </div>
                  <div ref={ref4}>
                    <Tooltip title="Send Individual Reminders">
                      <Popconfirm
                        title="Send Individual Reminders?"
                        onConfirm={sendIndividualReminders}
                      >
                        <Button
                          type="text"
                          className="action-btn"
                          disabled={!hasSelected}
                          loading={qbLoading}
                          icon={<MailOutlined style={{ fontSize: "18px" }} />}
                          size="large"
                        />
                      </Popconfirm>
                    </Tooltip>
                  </div>
                  <div ref={ref5}>
                    <Tooltip title="Export">
                      <Button
                        type="text"
                        className="action-btn"
                        icon={<DownloadOutlined style={{ fontSize: "18px" }} />}
                        size="large"
                        onClick={() => {
                          exportDetailFile(detailData, {
                            selectedCurrent,
                            selected_1_30,
                            selected_31_60,
                            selected_61_90,
                            selected_90,
                          });
                        }}
                      />
                    </Tooltip>
                  </div>
                </div>
              </div>

              <div className="filter-group" ref={ref6}>
                <span
                  style={{
                    fontSize: "14px",
                    color: "#6b7280",
                    whiteSpace: "nowrap",
                  }}
                >
                  Status:
                </span>
                <MultipleSelect
                  className="filter-select"
                  placeholder="All"
                  defaultValue={statusSelected}
                  options={statusOptions}
                  onSelect={(values) => {
                    if (idClient) {
                      setStatusSelected(values as any);
                      searchParams.delete("status");
                      handleChangeFilters("detail", idClient, "status", values);
                    }
                  }}
                />
              </div>

              <div className="filter-group" ref={ref7}>
                <span
                  style={{
                    fontSize: "14px",
                    color: "#6b7280",
                    whiteSpace: "nowrap",
                  }}
                >
                  Customer:
                </span>
                <MultipleSelect
                  className="filter-select"
                  placeholder="All"
                  defaultValue={customerFiltered}
                  options={customerOptions}
                  onSelect={(values) => {
                    setCustomerFiltered([]);
                    setCustomerSelected(values as any);
                    searchParams.delete("add_filter");
                    idClient &&
                      handleChangeFilters(
                        "detail",
                        idClient,
                        "customer",
                        values,
                      );
                  }}
                />
              </div>

              <div className="filter-group filter-followup">
                <Tooltip title="Show only invoices with a follow up date">
                  <Checkbox
                    checked={hasFollowUpDate}
                    onChange={(e) => {
                      const checked = e.target.checked;
                      setHasFollowUpDate(checked);
                      if (checked) {
                        setNextFollowUpDate(null);
                        if (idClient) {
                          handleChangeFilters(
                            "detail",
                            idClient,
                            "nextFollowUp",
                            ["any"],
                          );
                        }
                      } else {
                        if (idClient) {
                          handleChangeFilters(
                            "detail",
                            idClient,
                            "nextFollowUp",
                            [],
                          );
                        }
                      }
                    }}
                  />
                </Tooltip>
                <span
                  style={{
                    fontSize: "14px",
                    color: "#6b7280",
                    whiteSpace: "nowrap",
                  }}
                >
                  Follow Up:
                </span>
                <DatePicker
                  className="modern-date-picker filter-date-picker"
                  format="MMM DD, YYYY"
                  placeholder="Select date"
                  value={nextFollowUpDate}
                  disabled={hasFollowUpDate}
                  onChange={(date: Dayjs | null) => {
                    setNextFollowUpDate(date);
                    if (date && idClient) {
                      setHasFollowUpDate(false);
                      handleChangeFilters("detail", idClient, "nextFollowUp", [
                        date.format("YYYY-MM-DD"),
                      ]);
                    } else if (!date && idClient) {
                      handleChangeFilters(
                        "detail",
                        idClient,
                        "nextFollowUp",
                        [],
                      );
                    }
                  }}
                />
              </div>

              <div className="filter-group">
                <div className="filter-search">
                  <SearchInput
                    placeholder="Search clients or invoices..."
                    onSearch={(value: string) => {
                      if (value) {
                        idClient &&
                          getData({
                            endpoint: "detail",
                            idClient,
                            search: value,
                          });
                      } else {
                        idClient && getData({ endpoint: "detail", idClient });
                      }
                    }}
                  />
                </div>
              </div>
            </div>
          </div>
        </ColumnComponent>
        <ColumnComponent>
          <>
            {items && items.length > 0 ? (
              <div
                ref={screenRef}
                style={{ backgroundColor: "#fff" }}
                id="screenshot"
              >
                <Tabs
                  className="detail-client__tabs"
                  items={items}
                  activeKey={activeTab}
                  onChange={(key) => {
                    searchParams.delete("filter");
                    setActiveTab(key);
                  }}
                  tabBarExtraContent={
                    detailData.total && (
                      <Space size={8} style={{ padding: "0 16px" }}>
                        <strong style={{ color: "var(--slate-700)" }}>
                          Total:
                        </strong>
                        <span
                          style={{
                            color: "var(--primary)",
                            fontSize: "1.125rem",
                            fontWeight: 700,
                          }}
                        >
                          {USDollar.format(detailData.total)}
                        </span>
                      </Space>
                    )
                  }
                />
              </div>
            ) : (
              <Tabs
                className="detail-client__tabs"
                items={[]}
                activeKey={activeTab}
              />
            )}
          </>
        </ColumnComponent>
        <ColumnComponent>
          <div style={{ textAlign: "right", marginTop: "16px" }}>
            <Tooltip title="Help">
              <Button
                icon={
                  <QuestionCircleOutlined
                    style={{ color: "var(--primary)", fontSize: "18px" }}
                  />
                }
                type="default"
                size="large"
                onClick={() => {
                  handleTour(true);
                }}
                style={{
                  borderRadius: "8px",
                  transition: "all 0.3s ease",
                }}
              />
            </Tooltip>
          </div>
        </ColumnComponent>
      </Row>
      <InvoiceDrawer
        title={`Collections (${invoiceSelected.TransactionType} ${
          indexInvoiceSelected + 1
        } of ${invoiceListSelected.length})`}
        open={isInvoiceDrawerOpen}
        onClose={handleCancelSelectInvoiceList}
        invoice={invoiceSelected}
        options={statusList}
        idClient={idClient}
        indexInvoiceSelected={indexInvoiceSelected}
        list={invoiceListSelected}
        selectInvoice={(indexSelected) => handleSelectInvoice(indexSelected)}
        onClickNext={
          indexInvoiceSelected < invoiceListSelected.length - 1
            ? () => handleSelectInvoice(indexInvoiceSelected + 1)
            : undefined
        }
        onClickPrevious={
          indexInvoiceSelected !== undefined && indexInvoiceSelected > 0
            ? () => handleSelectInvoice(indexInvoiceSelected - 1)
            : undefined
        }
        onSubmit={(newNote, emailAddress, phoneNumber, newDate, next) => {
          if (isDemoEnv) {
            openModalDemo();
          } else {
            if (idClient) {
              updateSelectedInvoice(
                idClient,
                {
                  newNote,
                  emailAddress,
                  phoneNumber,
                  newDate,
                },
                () => {
                  next && next();
                  getSourceData();
                },
              );
            }
          }
        }}
      />
      <ModalCollectionsBulkUpdate
        title="Edit Selected Invoice(s)"
        isModalOpen={isEditModalOpen}
        onSubmit={editInvoices}
        onCancel={() => {
          setIsEditModalOpen(false);
        }}
      />
      <Tour open={isTourOpen} onClose={() => handleTour(false)} steps={steps} />
      <DemoModal />
    </>
  );
};
